import { api } from './client';
import type {
  Product,
  ProductBulkResult,
  ProductCreateRequest,
  ProductUpdateRequest,
} from '../types';

export interface ProductQuery {
  storeId?: number | null;
  categoryId?: number | null;
  q?: string;
  posOnly?: boolean;
}

export const productsApi = {
  list: (query: ProductQuery = {}) =>
    api
      .get<Product[]>('/products', {
        params: {
          storeId: query.storeId ?? undefined,
          categoryId: query.categoryId ?? undefined,
          q: query.q || undefined,
          posOnly: query.posOnly ?? false,
        },
      })
      .then((r) => r.data),

  create: (body: ProductCreateRequest) =>
    api.post<Product>('/products', body).then((r) => r.data),

  bulkCreate: (items: ProductCreateRequest[]) =>
    api
      .post<ProductBulkResult>('/products/bulk', { items })
      .then((r) => r.data),

  update: (id: number, body: ProductUpdateRequest) =>
    api.put<Product>(`/products/${id}`, body).then((r) => r.data),

  setAvailability: (id: number, available: boolean) =>
    api
      .patch<Product>(`/products/${id}/availability`, null, {
        params: { available },
      })
      .then((r) => r.data),

  deactivate: (id: number) =>
    api.delete<void>(`/products/${id}`).then((r) => r.data),

  uploadImage: (id: number, file: File, makePrimary = false) => {
    const form = new FormData();
    form.append('file', file);
    return api
      .post<Product>(`/products/${id}/image`, form, {
        params: makePrimary ? { makePrimary: true } : undefined,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },
};
